import { render } from "./SeeMoreButton.vue?vue&type=template&id=5a3a7bbe"
import script from "./SeeMoreButton.vue?vue&type=script&lang=js"
export * from "./SeeMoreButton.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__